module.exports = __webpack_public_path__ + "img/play-button.2c17ce16.svg";